import { View } from "@/components/ui";
import { Link } from "@/components/shared/link";
import { AccountMyReferralBanner } from "@/containers/profile/account-my-referral/account-my-referral-banner";
import { WarningCircle } from "@/components/shared/icons";
import { Typography } from "@/components/shared/typography";
import { MakeABooking } from "@/containers/make-a-booking";
import { useAvailableClientVouchersStore } from "@/store/invoices/useAvailableClientVouchers";
import { Spin } from "@/components/shared/spin";
import { useAuthState } from "@/store/auth";
import { useEffect } from "react";
import { IfElse } from "@/components/shared/if-else";
import { VoucherCard } from "@/components/shared/voucher-card";
import { EmptyCard } from "@/components/shared/empty-card";
import NoVouchers from "@/assets/images/3d-illus/no-vouchers.png";

export const ClientVoucherContainer = () => {
  const clientId = useAuthState((state) => state.data.userInfo.id);
  const {
    fetch: getVouchers,
    data = [],
    loading,
  } = useAvailableClientVouchersStore();

  useEffect(() => {
    if (clientId) {
      getVouchers({
        requestPayload: {
          clientId,
        },
      });
    }
  }, [clientId]);

  return (
    <View className="flex flex-col gap-3 p-4 md:px-0">
      <View className="md:mx-0">
        <AccountMyReferralBanner />
        <View className="mt-4 flex flex-row gap-2 rounded-xl bg-background-intermediate p-3">
          <WarningCircle weight="fill" className="text-primary" size={20} />
          <View className="native:max-w-[300px] flex w-full flex-col gap-1">
            <Typography color="secondary-text" variant="body-sm">
              Vouchers can be applied to invoices to reduce your bill. You can
              use the vouchers from the invoice page.
            </Typography>
            <Link href="/profile/invoices">
              <Typography color="brand-primary" variant="body-sm">
                View my invoices
              </Typography>
            </Link>
          </View>
        </View>
      </View>

      {loading ? (
        <Spin className="my-6 size-8" />
      ) : (
        <IfElse
          if={!!data?.length}
          else={
            <EmptyCard
              src={NoVouchers}
              title="No Vouchers Yet!"
              desc="Check back soon for new vouchers!"
            />
          }
        >
          <View className="flex flex-col gap-4 md:p-0">
            {data?.map((voucher) => (
              <VoucherCard
                key={voucher.id}
                expirationDate={voucher.expirationDate}
                label={voucher.description}
                discountValues={voucher.discountValues}
                discountType={voucher.discountType}
              />
            ))}
          </View>
        </IfElse>
      )}

      <MakeABooking />
    </View>
  );
};
